// extracted by mini-css-extract-plugin
export default {"container":"Nature_container_Hh9CB","content":"Nature_content_pRRGz","row":"Nature_row_hwu0C","title":"Nature_title_xq0QS","subtext":"Nature_subtext_Rgn2G"};